(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-checkout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var cfg = {
        freeShipMinQty: parseInt(root.dataset.freeShippingMinQty, 10) || 2,
        freeShipThresholdCents: parseInt(root.dataset.freeShippingThresholdCents, 10) || 10000,
        shippingChargeCents: parseInt(root.dataset.shippingChargeCents, 10) || 875,
        shipFreeLabel: root.dataset.shippingFreeLabel || 'FREE',
        klarnaTpl: root.dataset.klarnaText || '',
        stickySingular: root.dataset.stickySingular || 'Pillow',
        stickyPlural: root.dataset.stickyPlural || 'Pillows',
        stickyAddonsSuffix: root.dataset.stickyAddonsSuffix || ' + addons',
        checkoutUrl: root.dataset.checkoutUrl || '/checkout',
        cartAddUrl: root.dataset.cartAddUrl || '/cart/add.js',
        discountKey: root.dataset.discountStorageKey || 'co-bundle-discount'
      };

      var bundleEls = Array.prototype.slice.call(root.querySelectorAll('.bundle'));
      var addonEls = Array.prototype.slice.call(root.querySelectorAll('.addon'));
      var lineItemsEl = root.querySelector('[data-line-items]');
      var subtotalEl = root.querySelector('[data-subtotal]');
      var savingsEl = root.querySelector('[data-savings]');
      var shippingEl = root.querySelector('[data-shipping]');
      var totalEl = root.querySelector('[data-total]');
      var klarnaEl = root.querySelector('[data-klarna]');
      var stickyTotalEl = root.querySelector('[data-sticky-total]');
      var stickySummaryEl = root.querySelector('[data-sticky-summary]');
      var continueButtons = Array.prototype.slice.call(root.querySelectorAll('[data-continue]'));
      var continueLabelEl = root.querySelector('[data-continue-label]');
      var defaultContinueLabel = continueLabelEl ? continueLabelEl.textContent : 'Continue';

      function fmt(cents) {
        var n = (cents || 0) / 100;
        if (Math.abs(n - Math.round(n)) < 0.005) return '$' + Math.round(n);
        return '$' + n.toFixed(2);
      }

      function readBundle(el) {
        return {
          el: el,
          variantId: el.getAttribute('data-variant-id'),
          qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
          priceCents: parseInt(el.getAttribute('data-price-cents'), 10) || 0,
          compareCents: parseInt(el.getAttribute('data-compare-cents'), 10) || 0,
          savingsCents: parseInt(el.getAttribute('data-savings-cents'), 10) || 0,
          name: el.getAttribute('data-name') || '',
          sub: el.getAttribute('data-sub') || '',
          image: el.getAttribute('data-image') || '',
          discountCode: el.getAttribute('data-discount-code') || ''
        };
      }

      function readAddon(el) {
        return {
          el: el,
          variantId: el.getAttribute('data-variant-id'),
          priceCents: parseInt(el.getAttribute('data-price-cents'), 10) || 0,
          name: el.getAttribute('data-name') || '',
          sub: el.getAttribute('data-sub') || '',
          image: el.getAttribute('data-image') || '',
          checked: el.querySelector('input[type=checkbox]') ? el.querySelector('input[type=checkbox]').checked : false
        };
      }

      function selectedBundle() {
        for (var i = 0; i < bundleEls.length; i++) {
          var input = bundleEls[i].querySelector('input[type=radio]');
          if (input && input.checked) return readBundle(bundleEls[i]);
        }
        return null;
      }

      function selectedAddons() {
        return addonEls.map(readAddon).filter(function (a) { return a.checked; });
      }

      function imgHtml(src, alt) {
        if (!src) return '';
        var safeAlt = (alt || '').replace(/"/g, '&quot;');
        return '<img src="' + src + '" alt="' + safeAlt + '" loading="lazy"/>';
      }

      function escapeHtml(str) {
        return (str || '').replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function recompute() {
        var b = selectedBundle();
        var addons = selectedAddons();

        if (!b) {
          if (lineItemsEl) lineItemsEl.innerHTML = '';
          if (subtotalEl) subtotalEl.textContent = '';
          if (savingsEl) savingsEl.textContent = '';
          if (shippingEl) shippingEl.textContent = '';
          if (totalEl) totalEl.textContent = '';
          if (stickyTotalEl) stickyTotalEl.textContent = '';
          if (stickySummaryEl) stickySummaryEl.textContent = '';
          continueButtons.forEach(function (btn) { btn.setAttribute('disabled', ''); });
          return;
        }
        continueButtons.forEach(function (btn) { btn.removeAttribute('disabled'); });

        var addonTotal = addons.reduce(function (s, a) { return s + a.priceCents; }, 0);
        var subtotal = b.priceCents + addonTotal;
        var savings = b.savingsCents;

        var qualifiesForFreeShip = subtotal >= cfg.freeShipThresholdCents;
        var shipping = qualifiesForFreeShip ? 0 : cfg.shippingChargeCents;
        var total = subtotal + shipping;

        // Line items
        var rows = [];
        rows.push(
          '<div class="line-item">' +
            '<div class="img">' + imgHtml(b.image, b.name) + '</div>' +
            '<div class="body">' +
              '<div class="name">' + escapeHtml(b.name) + '</div>' +
              (b.sub ? '<div class="sub">' + escapeHtml(b.sub) + '</div>' : '') +
            '</div>' +
            '<div class="price">' + fmt(b.priceCents) + '</div>' +
          '</div>'
        );
        addons.forEach(function (a) {
          rows.push(
            '<div class="line-item">' +
              '<div class="img">' + imgHtml(a.image, a.name) + '</div>' +
              '<div class="body">' +
                '<div class="name">' + escapeHtml(a.name) + '</div>' +
                (a.sub ? '<div class="sub">' + escapeHtml(a.sub) + '</div>' : '') +
              '</div>' +
              '<div class="price">' + fmt(a.priceCents) + '</div>' +
            '</div>'
          );
        });
        if (lineItemsEl) lineItemsEl.innerHTML = rows.join('');

        if (subtotalEl) subtotalEl.textContent = fmt(subtotal);
        if (savingsEl) savingsEl.textContent = savings > 0 ? '−' + fmt(savings) : fmt(0);

        if (shippingEl) {
          if (shipping === 0) {
            shippingEl.textContent = cfg.shipFreeLabel;
            shippingEl.classList.add('free');
          } else {
            shippingEl.textContent = fmt(shipping);
            shippingEl.classList.remove('free');
          }
        }

        if (totalEl) totalEl.textContent = fmt(total);

        if (klarnaEl && cfg.klarnaTpl) {
          klarnaEl.innerHTML = cfg.klarnaTpl.replace('[amount]', '<strong>' + fmt(Math.round(total / 4)) + '</strong>');
        }

        if (stickyTotalEl) stickyTotalEl.textContent = fmt(total);
        if (stickySummaryEl) {
          var unit = b.qty > 1 ? cfg.stickyPlural : cfg.stickySingular;
          stickySummaryEl.textContent = b.qty + ' ' + unit + (addons.length > 0 ? cfg.stickyAddonsSuffix : '');
        }
      }

      // Bundle radio binding
      bundleEls.forEach(function (el) {
        var input = el.querySelector('input[type=radio]');
        if (!input) return;
        input.addEventListener('change', recompute);
      });

      // Addon checkbox binding
      addonEls.forEach(function (el) {
        var input = el.querySelector('input[type=checkbox]');
        if (!input) return;
        input.addEventListener('change', recompute);
      });

      // Continue → /cart/add.js → /checkout
      continueButtons.forEach(function (btn) {
        btn.addEventListener('click', async function () {
          var b = selectedBundle();
          if (!b || !b.variantId) return;

          continueButtons.forEach(function (x) { x.classList.add('is-loading'); x.setAttribute('disabled', ''); });
          if (continueLabelEl) continueLabelEl.textContent = 'Adding to cart…';

          var items = [{ id: parseInt(b.variantId, 10), quantity: b.qty }];
          selectedAddons().forEach(function (a) {
            if (a.variantId) items.push({ id: parseInt(a.variantId, 10), quantity: 1 });
          });

          try {
            var res = await fetch(cfg.cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });
            if (!res.ok) {
              var msg = 'Could not add to cart.';
              try {
                var data = await res.json();
                if (data && data.description) msg = data.description;
              } catch (err) {}
              throw new Error(msg);
            }
          } catch (err) {
            console.error('[bundle-checkout] cart/add failed', err);
            continueButtons.forEach(function (x) { x.classList.remove('is-loading'); x.removeAttribute('disabled'); });
            if (continueLabelEl) continueLabelEl.textContent = defaultContinueLabel;
            alert(err && err.message ? err.message : 'Could not add to cart. Please try again.');
            return;
          }

          var code = b.discountCode || '';
          if (!code) {
            try { code = localStorage.getItem(cfg.discountKey) || ''; } catch (e) { code = ''; }
          }
          var checkoutUrl = cfg.checkoutUrl;
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(checkoutUrl);
          } else {
            window.location.href = checkoutUrl;
          }
        });
      });

      recompute();
    }

    function bootAll() {
      var roots = document.querySelectorAll('.co-bundle-checkout');
      Array.prototype.forEach.call(roots, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    // Re-init when re-rendered in the theme editor
    document.addEventListener('shopify:section:load', bootAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
